<template>
  <modal
    :width="300"
    :height="210"
    :click-to-close="false"
    name="remove-modal"
    @opened="modalOpened"
    @closed="modalClosed"
    @before-open="beforeOpen"
  >
    <div class="remove-modal" >
      <div
        class="remove-header"
      >Remove
      </div>
      <div class="dt pa2">
        <div class="dtc v-mid"><img
          src="./assets/alert.png"
          alt="alert"></div>
        <div class="dtc msg">
          Are you sure you want to remove
          <strong>{{ columnToRemove }}</strong>
          from the report?</div>
      </div>
      <div class="remove-button">
        <button
          ref="removeButton"
          class="green-button default-button remove"
          @keydown.shift.tab="setFocusToCancelButton"
          @click="removeClicked">Remove</button>
        <button
          ref="cancelButton"
          @keydown.tab="setFocusToRemoveButton"
          @click="cancelClicked">Cancel</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      id: '',
      categoryId: '',
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      reportType: state => state.CR.GSGo.reportType,
      compareColumns: state => state.CR.compareColumns,
    }),
    columnToRemove() {
      if (!this.id) return { id: '', name: '' };
      return _(this.compareColumns).find({ id: this.id }).name;
    },
  },
  methods: {
    modalOpened() {
      this.$refs.removeButton.focus();
    },
    modalClosed() {
      this.$emit('modalClosed', this.categoryId);
    },
    beforeOpen(event) {
      // console.log(event.params.id);
      this.id = event.params.id;
      this.categoryId = event.params.categoryId;
    },
    clearId() {
      // clear the id to prevent errors in columnToRemove when compareColumns is updated via Go button
      this.id = '';
    },
    removeClicked() {
      const newCompareColumns = _(this.compareColumns).filter(o => o.id !== this.id).value();
      this.clearId();
      this.$store.commit('CR/setCompareColumns', newCompareColumns);
      this.$store.dispatch('CR/triggerInteraction', { type: 'CRC' });
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
      this.$modal.hide('remove-modal');
    },
    cancelClicked() {
      this.clearId();
      this.$modal.hide('remove-modal');
    },
    setFocusToCancelButton() {
      this.$nextTick(() => {
        this.$refs.cancelButton.focus();
      });
    },
    setFocusToRemoveButton() {
      this.$nextTick(() => {
        this.$refs.removeButton.focus();
      });
    },
  },
};
</script>

<style scoped>
  .msg {
    padding: 10px;
    height: 100px;
  }

  .remove {
    width: 64px;
  }

  .dt {
    display: table;
  }

  .dtc {
    display: table-cell;
  }

  .v-mid {
    vertical-align: middle;
  }

  .pa2 {
    padding: .5rem;
  }

  .remove-modal {
    text-align: left;
    border:solid 3px rgb(186, 185, 185);
    height: 640px;
    padding: 2px 2px 2px 2px;
    z-index: 2000;
  }

  .remove-header{
    background-color: #084239;
    color:white;
    font-size: 18px;
    line-height: 30px;
    margin-top: 0px;
    padding: 0 0 0 8px;
  }
  .remove-button {
    align-content: center;
    text-align: center;
    padding: 10px 0 10px 0;
    margin: 0 0 10px 0;
  }

  .remove-button button {
    width: 70px;
    margin: 0 5px;
    height: 37px;
    font-size: 14px;
    font-weight: bold;
  }

  .remove-button .green-button {
    background-color: #084239;
    color: white;
    border:solid 1px #042b25;
  }

  .remove-button .disabledButton {
    background-color: #F6F6F6;
    color: #CECECE;
  }

</style>



// WEBPACK FOOTER //
// src/components/CR/CRRemoveModal.vue